import { Avatar, Box, Button, Typography } from "@mui/material"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
// import dummyAvatar from "src/assets/images/default_avatar.svg";
// import banner from "src/assets/images/my-account-banner.jpg";
import { BiChevronRight } from "react-icons/bi";
import Footer from "src/components/footer/footer";
import { FOOTER_TAB_INDEX } from "src/utils/enum";

export const MyAccount = () => {
    const navigate = useNavigate()

    const [lists, setLists] = useState([
        {
            name: "My RFQs",
        },
        {
            name: "My Inquiries",
        },
        {
            name: "Following List",
        },
        {
            name: "My Browsing History",
        },
        {
            name: "Delete Account",
        },
    ]);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const onClickLogin = () => {
        navigate("/login");
    }

    const onClickRegister = () => {
        navigate("/register");
    }

    const onClickList = (item) => {
        
    }

    return (
        <div className="mobile-view" style={{
            backgroundColor: "#ffffff",
            height: "100vh"
        }}>
            <Box className="my-account-page">

                <Box pt={3} className="d-flex justify-content-center">
                    <Typography
                        variant="paragraph"
                        className="title"
                    >
                        My Account
                    </Typography>
                </Box>

                <Box mt={2} pl={4} pr={4}>
                    <Box className="d-flex">
                        {/* <Avatar
                            src={dummyAvatar}
                            className="avatar-image"
                        /> */}

                        <Button
                            disableElevation
                            variant="contained"
                            onClick={() => {
                                onClickLogin();
                            }}
                            className="login-button"
                            sx={{
                                borderRadius: "25px",
                                color: "#ec301d",
                                backgroundColor: "rgba(236, 48, 29, .051)",
                            }}
                        >
                            Sign In
                        </Button>

                        <Button
                            disableElevation
                            variant="contained"
                            onClick={() => {
                                onClickRegister();
                            }}
                            className="register-button"
                            sx={{
                                borderRadius: "25px",
                                color: "#ec301d",
                                backgroundColor: "rgba(236, 48, 29, .051)",
                            }}
                        >
                            Register
                        </Button>
                    </Box>

                    <Box mt={1} mb={1}>
                        {/* <Avatar
                            variant="square"
                            src={banner}
                            className="banner-image"
                        /> */}
                    </Box>

                    <Box>
                        {lists?.map((item, index) => (
                            <Box
                                key={item.id}
                                className="d-flex justify-content-between"
                                sx={{
                                    paddingTop: "18px",
                                    paddingBottom: "18px",
                                    borderBottom: "1px solid #ddd",
                                    cursor: "pointer",
                                }}
                                onClick={() => {
                                    onClickList(item);
                                }}
                            >
                                <Box>
                                    <Typography
                                        variant="paragraph"
                                        className="list-name"
                                    >
                                        {item.name}
                                    </Typography>
                                </Box>
                                <Box>
                                    <BiChevronRight color="#ddd" className="chevron-right-icon" />
                                </Box>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>
            
            <Footer activeIndex={FOOTER_TAB_INDEX.MY_ACOUNT}/>
        </div>
    )
}

export default MyAccount
